export default __webpack_public_path__ + "assets/images/4e7123057023a7b58e822d94f4a0977d.png";